<template>
    <ModalBase
        :name="'borrar-sancion-' + sancion.id"
        :title="'Borrar sanción de ' + abonado.name + ' ' + abonado.surnames"
        @close="close(false)"
    >
        <div class="tw:space-y-6">
            <div>
                <p class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-400 tw:mb-3">Datos del abonado</p>
                <div class="tw:grid tw:grid-cols-2 tw:gap-4">
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Nº de abonado</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ abonado.n_abonado }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Nombre</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ abonado.name }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Apellidos</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ abonado.surnames }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">DNI</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ abonado.dni }}</p>
                    </div>
                    <div class="tw:col-span-2">
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Email</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ abonado.email }}</p>
                    </div>
                    <div class="tw:col-span-2">
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Asiento Zona</p>
                        <p class="tw:text-sm tw:text-gray-900">
                            <template v-if="abonado.tiene_asiento">
                                Zona: {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                            </template>
                            <template v-else>
                                Sin asiento
                            </template>
                        </p>
                    </div>
                </div>
            </div>

            <div>
                <p class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-400 tw:mb-3">Datos de la sanción</p>
                <div class="tw:grid tw:grid-cols-2 tw:gap-4">
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Fecha de inicio</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ sancion.fecha_inicio }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Fecha de fin</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ sancion.fecha_fin }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Acceso bloqueado</p>
                        <p class="tw:text-sm tw:text-gray-900">
                            <CheckOrCross :condition="sancion.bloquear_acceso"/>
                        </p>
                    </div>
                    <div class="tw:col-span-2">
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Motivo</p>
                        <p class="tw:text-sm tw:text-gray-900" v-html="sancion.motivo"></p>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <Button variant="danger" @click="borrarAbonado">SI, BORRAR</Button>
        </template>
    </ModalBase>
</template>

<script setup>
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import CheckOrCross from "@/components/backend/components/CheckOrCross"
    import ModalBase from '@/modules/admin/ui/ModalBase'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        abonado: Object,
        sancion: Object
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const close = (borrado = false, errorMessage = null) => {
        emit('close', 'borrar-sancion-' + props.sancion.id, borrado, errorMessage)
    }

    const borrarAbonado = () => {
        const params = {
            filters: {},
            abonado_id: props.abonado.id,
            sancion_id: props.sancion.id
        }

        store.dispatch(config.getVuexAlias('back.abonados.sancion.borrar'), params)
            .then(res => {
                const successMessage = res.data?.message || 'Sanción eliminada correctamente'
                toast.success(successMessage)
                close(true)
            })
            .catch(err => {
                const errorMessage = err.response?.data?.message || 'Error al eliminar sanción'
                toast.error(errorMessage)
                close(false)
            })
    }
</script>
